import { UxStyleEnum, UxThemesEnum } from "@imaginelearning/mps-ux-component-library";
import useTheme from "./usetheme";

const k5Themes = [UxThemesEnum.STUDENT_K_2, UxThemesEnum.STUDENT_3_5];
const from3to5Themes = [UxThemesEnum.STUDENT_3_5];
const from6to12Themes = [UxThemesEnum.STUDENT_6_8, UxThemesEnum.STUDENT_9_12];

const useGradeRange = () => {
  const { theme } = useTheme();

  const isKto2: boolean = theme === UxThemesEnum.STUDENT_K_2;
  const isKto5: boolean = k5Themes.includes(theme);
  const is3to5 = from3to5Themes.includes(theme);
  const is6to8: boolean = theme === UxThemesEnum.STUDENT_6_8;
  const isKto8: boolean = isKto5 || is6to8;
  const is6to12: boolean = from6to12Themes.includes(theme);
  const is9to12: boolean = theme === UxThemesEnum.STUDENT_9_12;
  const is3plus: boolean = is3to5 || is6to8 || is6to12;

  const gradeButtonStyle = (): UxStyleEnum | undefined => {
    if (!is6to12) {
      return UxStyleEnum.ROUNDED;
    }
    return undefined;
  };

  return { isKto2, isKto5, isKto8, is3to5, is6to8, is9to12, is6to12, is3plus, gradeButtonStyle };
};

export default useGradeRange;
